import * as React from "react";
import { Box, TextField, Stack, Typography } from "@mui/material";

export default function NumberInput({ label, value, callback, min = 0, max = 10000 }) {
   const handleChange = (event) => {
      const newValue = event.target.value === "" ? 0 : Number(event.target.value);
      if (newValue >= min && newValue <= max) {
         callback(newValue);
      }
   };

   return (
      <Stack direction='row' spacing={2} alignItems='center'>
         <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
            {label}
         </Typography>
         <TextField
            type="number"
            value={value}
            onChange={handleChange}
            inputProps={{ min, max }}
            sx={{ width: 120 }}
            size="small"
         />
      </Stack>
   );
}
